module.exports = __webpack_public_path__ + "img/07_cg.36313b26.png";